import { IMAGE_CONFIG, IMAGE_LOADER } from "@angular/common";
import { Provider } from "@angular/core";

import {
    scene7ImageConfigFactory,
    scene7ImageLoaderFactory,
} from "./scene7-image-loader";
import {
    DEFAULT_SCENE7_IMAGE_SETTINGS,
    SCENE7_IMAGE_SETTINGS,
    Scene7ImageSettings,
} from "./scene7-image-settings";

export function provideScene7Loader(
    settings?: Partial<Scene7ImageSettings>,
): Provider[] {
    return [
        ...(settings ? provideScene7ImageSettings(settings) : []),
        {
            provide: IMAGE_LOADER,
            useFactory: scene7ImageLoaderFactory,
        },
        {
            provide: IMAGE_CONFIG,
            useFactory: scene7ImageConfigFactory,
        },
    ];
}

/**
 * Override default Scene7 settings
 *
 * Omitted settings will use {@link DEFAULT_SCENE7_IMAGE_SETTINGS default values}.
 *
 * @param settings
 *
 * @see Scene7ImageSettings
 * @see DEFAULT_SCENE7_IMAGE_SETTINGS
 */
export function provideScene7ImageSettings(
    settings: Partial<Scene7ImageSettings>,
): Provider[] {
    return [
        {
            provide: SCENE7_IMAGE_SETTINGS,
            useValue: { ...DEFAULT_SCENE7_IMAGE_SETTINGS, ...settings },
        },
    ];
}
